module.exports = __webpack_public_path__ + "assets/img/25e77664aee3ab337637693d23f0be9a.png";